import * as COM from '../components';
const dataKanban = [
  /** ------------------------------ 其它报表 ------------------------------ */
  /** ------------------------------ 积分统计 ------------------------------ */
  {
    path: '/other-reports',
    component: COM.Layout,
    redirect: '/other-reports/integral-consume',
    name: 'data__otherReports',
    meta: { label: '其它报表' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 积分消耗
      {
        path: 'integral-consume',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralConsume,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralConsume',
        meta: { label: '积分消耗', icon: 'el-icon-document', menuKeyPath: '/other-reports/integral-consume' }
      },
      // 积分日报
      {
        path: 'integral-daily',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralDaily,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralDaily',
        meta: { label: '积分日报', icon: 'el-icon-document', menuKeyPath: '/other-reports/integral-daily' }
      },
      // 积分发放
      {
        path: 'integral-grant',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralGrant,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralGrant',
        meta: { label: '积分发放', icon: 'el-icon-document', menuKeyPath: '/other-reports/integral-grant' }
      },
      // 事业部对账日报
      {
        path: 'integral-org-accounts',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralOrgAccounts,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralOrgAccounts',
        meta: { label: '事业部对账日报', icon: 'el-icon-document', menuKeyPath: '/other-reports/integral-org-accounts' }
      },
      // 任务看板
      {
        path: 'task-kanban',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.TaskKanban,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'taskKanban',
        meta: { label: '任务看板', icon: 'el-icon-document', menuKeyPath: '/other-reports/task-kanban' }
      }
    ]
  },
  /** ------------------------------ 会员分析 ------------------------------ */
  {
    path: '/member-analysis',
    component: COM.Layout,
    redirect: '/data-kanban/member-analysis',
    name: 'data__memberAnalysis',
    meta: { label: '会员分析' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 会员分析
      {
        path: '/data-kanban/member-analysis',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MemberAnalysis,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'memberAnalysis',
        meta: { label: '会员分析', icon: 'el-icon-document', parent: 'data__memberAnalysis', menuKeyPath: '/data-kanban/member-analysis' }
      },
      // 会员分析明细
      {
        path: '/data-kanban/member-analysis',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/data-kanban/member-analysis/detail',
        name: 'memberAnalysisInside',
        meta: { label: '会员分析', insidePageFrom: 'memberAnalysis' },
        children: [
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberAnalysisDetail
            },
            name: 'memberAnalysisDetail',
            meta: { label: '会员分析明细', icon: 'el-icon-document', menuKeyPath: '/data-kanban/member-analysis', authKey: 'memberAnalysis' }
          }
        ]
      },
    ]
  },
  /** ------------------------------ 来源分析 ------------------------------ */
  {
    path: '/source-analysis',
    component: COM.Layout,
    redirect: '/data-kanban/source-analysis',
    name: 'data__SourceAnalysis',
    meta: { label: '来源分析' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 来源分析
      {
        path: '/data-kanban/source-analysis',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.SourceAnalysis,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'sourceAnalysisIndex',
        meta: { label: '来源分析', icon: 'el-icon-document', menuKeyPath: '/data-kanban/source-analysis' }
      },
      // 来源分析明细
      {
        path: '/data-kanban/source-analysis',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/data-kanban/source-analysis/detail',
        name: 'sourceAnalysisDetailInside',
        meta: { label: '来源分析', insidePageFrom: 'sourceAnalysisIndex' },
        children: [
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SourceAnalysisDetail
            },
            name: 'sourceAnalysisDetail',
            meta: { label: '来源明细', icon: 'el-icon-document', menuKeyPath: '/data-kanban/source-analysis', authKey: 'sourceAnalysisIndex' }
          }
        ]
      },
    ]
  },
  /** ------------------------------ 权益分析 ------------------------------ */
  {
    path: '/membership-grade',
    component: COM.Layout,
    redirect: '/data-kanban/membership-grade',
    name: 'data__rightAnalysis',
    meta: { label: '权益分析' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 会员等级
      {
        path: '/data-kanban/membership-grade',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MembershipGrade,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'membershipGrade',
        meta: { label: '会员等级', icon: 'el-icon-document', menuKeyPath: '/data-kanban/membership-grade' }
      },
      // 会员等级明细
      {
        path: '/data-kanban/membership-grade',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/data-kanban/membership-grade/detail',
        name: 'MembershipGradeDetailInside',
        meta: { label: '会员等级', insidePageFrom: 'membershipGrade' },
        children: [
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MembershipGradeDetail
            },
            name: 'membershipGradeDetail',
            meta: { label: '当天明细', icon: 'el-icon-document', menuKeyPath: '/data-kanban/membership-grade', authKey: 'membershipGrade' }
          }
        ]
      },
      // 会员积分
      {
        path: '/data-kanban/membership-integral',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MembershipIntegral,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'membershipIntegral',
        meta: { label: '会员积分', icon: 'el-icon-document', menuKeyPath: '/data-kanban/membership-integral' }
      },
      // 会员积分明细
      {
        path: '/data-kanban/membership-integral',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/data-kanban/membership-integral/detail',
        name: 'MembershipIntegralDetailInside',
        meta: { label: '会员积分', insidePageFrom: 'membershipIntegral' },
        children: [
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MembershipIntegralDetail
            },
            name: 'membershipIntegralDetail',
            meta: { label: '当天明细', icon: 'el-icon-document', menuKeyPath: '/data-kanban/membership-integral', authKey: 'membershipIntegral' }
          }
        ]
      },
    ]
  },
  /** ------------------------------ 留存分析 ------------------------------ */
  {
    path: '/retain-analysis',
    component: COM.Layout,
    redirect: '/data-kanban/retain-analysis',
    name: 'data__retainAnalysis',
    meta: { label: '留存分析' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 会员分析
      {
        path: '/data-kanban/retain-analysis',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.RetainAnalysis,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'retainAnalysis',
        meta: { label: '留存分析', icon: 'el-icon-document', menuKeyPath: '/data-kanban/retain-analysis' }
      }
    ]
  },
  /** ------------------------------ 销售分析 ------------------------------ */
  {
    path: '/sale-analysis',
    component: COM.Layout,
    redirect: '/data-kanban/sale-analysis',
    name: 'data__saleAnalysis',
    meta: { label: '销售分析' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 销售分析
      {
        path: '/data-kanban/sale-analysis',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.SaleAnalysis,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'saleAnalysis',
        meta: { label: '销售分析', icon: 'el-icon-document', menuKeyPath: '/data-kanban/sale-analysis' }
      }
    ]
  },
  /** ------------------------------ 勋章数据统计 ------------------------------ */
  {
    path: '/data-medal',
    component: COM.Layout,
    redirect: '/data-medal/daily',
    name: 'data__medal',
    meta: { label: '勋章数据统计' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 销售分析
      {
        path: 'daily',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MedalDaily,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'medalDaily',
        meta: { label: '勋章日报', icon: 'el-icon-document', menuKeyPath: '/data-medal/daily' }
      }
    ]
  }
];
export default dataKanban;
